"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.phone = phone;
exports.tablet = tablet;
exports.desktop = desktop;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TABLET_WIDTH = exports.TABLET_WIDTH = 600;
var DESKTOP_WIDTH = exports.DESKTOP_WIDTH = 1024;

function phone(styles) {
  return _defineProperty({}, "@media (max-width: " + (TABLET_WIDTH - 1) + "px)", _extends({}, styles));
}

function tablet(styles) {
  return _defineProperty({}, "@media (min-width: " + TABLET_WIDTH + "px)", _extends({}, styles));
}

function desktop(styles) {
  return _defineProperty({}, "@media (min-width: " + DESKTOP_WIDTH + "px)", _extends({}, styles));
}


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/styles/media.js
// module id = 117
// module chunks = 0